module.exports = __webpack_public_path__ + "img/referral-declared-icon.301f4c9c.svg";